import { HttpParams } from '@angular/common/http';

type ParamValue = string | number | boolean | (string | number)[] | undefined | null;

/** Converts a key-value map into HttpParams, joining arrays with commas and skipping falsy/empty values. */
export function toHttpParams(entries: Record<string, ParamValue>): HttpParams {
  let params = new HttpParams();
  for (const [key, value] of Object.entries(entries)) {
    if (value == null || value === '' || value === false) continue;
    if (Array.isArray(value)) {
      const joined = value.map(String).join(',');
      if (joined) params = params.set(key, joined);
    } else {
      params = params.set(key, String(value));
    }
  }
  return params;
}
